(function () {
  'use strict';

  window.VenucastSolutionFinderConfig = {
    version: 'find-my-setup-2026-09-30-v1',

    useCases: [
      { value: 'assistive_listening', icon: 'assistive', label: 'Assistive Listening', description: 'Help people hear speech clearly in public spaces' },
      { value: 'tours_training', icon: 'tour', label: 'Tours & Training', description: 'Guide groups with clear audio' },
      { value: 'silent_events', icon: 'silent', label: 'Silent Events', description: 'Audio without loudspeakers' },
      { value: 'overflow_remote', icon: 'rooms', label: 'Overflow / Remote Room', description: 'Send audio to another room or area' },
      { value: 'service_counter', icon: 'counter', label: 'Service Counter', description: 'One-to-one hearing access for banks, ticket counters and drive-thrus' },
      { value: 'not_sure', icon: 'help', label: 'Not Sure', description: 'Help me choose' }
    ],

    questions: {
      venueType: {
        eyebrowByUseCase: {
          assistive_listening: 'Assistive Listening',
          tours_training: 'Tours & Training',
          silent_events: 'Silent Events',
          overflow_remote: 'Overflow / Remote Room',
          service_counter: 'Service Counter',
          not_sure: 'Find Your Setup'
        },
        title: 'Where will it be used?',
        helper: 'Choose the option that best describes your venue.',
        optionsByUseCase: {
          assistive_listening: [
            { value: 'church', label: 'Church / House of Worship' },
            { value: 'theater', label: 'Theater / Performing Arts' },
            { value: 'classroom', label: 'Classroom / Lecture' },
            { value: 'meeting_room', label: 'Meeting Room' },
            { value: 'museum', label: 'Museum / Visitor Attraction' },
            { value: 'event_space', label: 'Restaurant / Event Space' },
            { value: 'transportation', label: 'Airport / Transportation' },
            { value: 'other', label: 'Other' }
          ],
          tours_training: [
            { value: 'museum', label: 'Museum / Visitor Attraction' },
            { value: 'site_tour', label: 'Factory / Site Tour' },
            { value: 'training_room', label: 'Training Room' },
            { value: 'classroom', label: 'Classroom / Lecture' },
            { value: 'outdoor_tour', label: 'Outdoor Tour' },
            { value: 'church', label: 'Church / House of Worship' },
            { value: 'other', label: 'Other' }
          ],
          silent_events: [
            { value: 'conference', label: 'Conference / Expo' },
            { value: 'fitness', label: 'Fitness Class' },
            { value: 'museum', label: 'Museum / Exhibit' },
            { value: 'performance', label: 'Performance' },
            { value: 'private_event', label: 'Private Event' },
            { value: 'outdoor_event', label: 'Outdoor Event' },
            { value: 'other', label: 'Other' }
          ],
          overflow_remote: [
            { value: 'church_overflow', label: 'Church Overflow' },
            { value: 'conference_breakout', label: 'Conference / Breakout Room' },
            { value: 'classroom', label: 'Classroom / Campus' },
            { value: 'lobby', label: 'Lobby / Waiting Area' },
            { value: 'outdoor_area', label: 'Outdoor Area' },
            { value: 'other', label: 'Other' }
          ],
          service_counter: [
            { value: 'bank', label: 'Bank / Credit Union' },
            { value: 'ticket_counter', label: 'Ticket Counter' },
            { value: 'reception', label: 'Reception / Front Desk' },
            { value: 'healthcare', label: 'Healthcare / Pharmacy' },
            { value: 'drive_thru', label: 'Drive-Thru' },
            { value: 'retail', label: 'Retail / Customer Service' },
            { value: 'other', label: 'Other' }
          ],
          not_sure: [
            { value: 'church', label: 'Church / House of Worship' },
            { value: 'theater', label: 'Theater / Performing Arts' },
            { value: 'classroom', label: 'Classroom / Lecture' },
            { value: 'meeting_room', label: 'Meeting Room' },
            { value: 'museum', label: 'Museum / Visitor Attraction' },
            { value: 'event_space', label: 'Restaurant / Event Space' },
            { value: 'transportation', label: 'Airport / Transportation' },
            { value: 'other', label: 'Other' }
          ]
        }
      },
      audienceSize: {
        title: 'How many people can the space hold?',
        helper: 'Choose the closest range.',
        options: [
          { value: 'under_50', label: 'Under 50' },
          { value: '50_100', label: '50–100' },
          { value: '100_300', label: '100–300' },
          { value: '300_plus', label: '300+' },
          { value: 'not_sure', label: 'Not sure' }
        ],
        overrides: {
          service_counter: {
            title: 'How many counters need hearing access?',
            helper: 'Choose the closest number of service points.',
            options: [
              { value: 'one', label: '1 counter' },
              { value: 'two_three', label: '2–3 counters' },
              { value: 'four_ten', label: '4–10 counters' },
              { value: 'ten_plus', label: '10+ counters' },
              { value: 'not_sure', label: 'Not sure' }
            ]
          }
        }
      },
      listeningDevices: {
        title: 'How will people listen?',
        helper: 'Select all that apply.',
        multiple: true,
        options: [
          { value: 'auracast', label: 'Auracast hearing aids / earbuds' },
          { value: 'tcoil', label: 'T-Coil hearing aids' },
          { value: 'bluetooth', label: 'Bluetooth hearing aids / earbuds' },
          { value: 'venue_receivers', label: 'Venue-provided receivers / headphones' },
          { value: 'mixed', label: 'A mix of different users' },
          { value: 'not_sure', label: 'Not sure' }
        ]
      }
    },

    systems: {
      auraplex_m3: {
        title: 'AuraPlex M3',
        subtitle: 'Compact assistive listening starter system',
        url: '/products/auraplex-m3-auracast-assistive-listening-kit',
        image: 'https://cdn.shopify.com/s/files/1/0775/7017/9296/files/5403r-auraplex-m3-main-1_315da017-949f-4203-8ed7-04cb64868794.png?v=1780481436',
        goodFor: ['Smaller venues', 'Mixed listening needs', 'Venue receivers + compatible Auracast devices']
      },
      auraplex_mx: {
        title: 'AuraPlex MX',
        subtitle: 'Assistive listening system with 10 venue receivers',
        url: '/products/auraplex-mx-auracast-wireless-transmitter-receiver',
        image: 'https://cdn.shopify.com/s/files/1/0775/7017/9296/files/AuraPlex-MX.png?v=1780562326',
        goodFor: ['50–300 person venues', 'Mixed hearing needs', 'Venue receivers + compatible Auracast devices']
      },
      auraplex_x20: {
        title: 'AuraPlex X20 Pro',
        subtitle: 'Long-range assistive listening system with 20 listening devices',
        url: '/products/auraplex-x20-pro-auracast-assistive-listening-system',
        image: 'https://cdn.shopify.com/s/files/1/0775/7017/9296/files/AuraPlex-X20-Pro.png?v=1782971798',
        goodFor: ['Larger venues', 'A managed listener-device pool', 'Mixed listening needs']
      },
      auditour: {
        title: 'AudiTour',
        subtitle: 'Portable tour guide system',
        url: '/products/auditour-wireless-tour-guide-system',
        image: 'https://cdn.shopify.com/s/files/1/0775/7017/9296/files/auditour-m1-tour-guide-system_s.1.png?v=1778147098',
        goodFor: ['Tours and mobile groups', 'Guide-to-group speech', 'Expandable venue receivers']
      },
      quartet_2: {
        title: 'Quartet 2 Silent Listening Setup',
        subtitle: 'Multi-user wireless listening system',
        url: '/products/quartet-2-multi-user-wireless-headphones-system',
        image: 'https://cdn.shopify.com/s/files/1/0775/7017/9296/files/quartet-2-5049P-m1_cb5cbfe2-ecc1-4349-8755-ff3e68313512.png?v=1769765518',
        goodFor: ['Small silent events', 'Audio without loudspeakers', 'Expandable wireless headphones']
      },
      ut90: {
        title: 'UT90 Silent Event Setup',
        subtitle: 'V-UT90 transmitter with scalable headphone packs',
        url: '/products/v-ut90-transmitter',
        image: 'https://cdn.shopify.com/s/files/1/0775/7017/9296/files/V-UT90-TX-M1-UHF-wireless-tramsmitter-for-UT90.png?v=1780554652',
        goodFor: ['Larger silent events', 'Scalable venue headphones', 'Events needing a dedicated wireless audio channel']
      },
      netcast: {
        title: 'NetCast',
        subtitle: 'Managed audio distribution system for separated spaces',
        url: '/products/netcast-enterprise-auracast-audio-distribution-system',
        image: 'https://cdn.shopify.com/s/files/1/0775/7017/9296/files/main-2.png?v=1789458007',
        goodFor: ['Overflow and remote rooms', 'Multiple listening areas', 'Professional site planning']
      },
      service_counter: {
        title: 'Service Counter Hearing Access',
        subtitle: 'One-to-one listening and caption solutions',
        url: '/pages/service-counter-hearing-access',
        image: '',
        goodFor: ['Banks, ticket counters and reception desks', 'Private one-to-one conversations', 'Listening or caption-based access']
      }
    },

    recommendations: [
      { id: 'service-counter', when: { useCase: ['service_counter'] }, system: 'service_counter' },
      { id: 'tour-system', when: { useCase: ['tours_training'] }, system: 'auditour' },
      { id: 'silent-large', when: { useCase: ['silent_events'], audienceSize: ['50_100', '100_300', '300_plus'] }, system: 'ut90' },
      { id: 'silent-small', when: { useCase: ['silent_events'] }, system: 'quartet_2' },
      { id: 'overflow-system', when: { useCase: ['overflow_remote'] }, system: 'netcast' },
      { id: 'unsure-museum', when: { useCase: ['not_sure'], venueType: ['museum'] }, system: 'auditour' },
      { id: 'assistive-large', when: { useCase: ['assistive_listening', 'not_sure'], audienceSize: ['300_plus'] }, system: 'auraplex_x20' },
      { id: 'assistive-medium', when: { useCase: ['assistive_listening', 'not_sure'], audienceSize: ['50_100', '100_300'] }, system: 'auraplex_mx' },
      { id: 'assistive-small', when: { useCase: ['assistive_listening', 'not_sure'] }, system: 'auraplex_m3' }
    ],

    addOns: {
      auracast: {
        title: 'For Auracast users',
        product: 'Connect directly',
        description: 'Compatible Auracast hearing aids and earbuds can receive the venue broadcast directly.',
        url: '/pages/auracast-compatibility-checker'
      },
      tcoil: {
        title: 'For T-Coil users',
        product: 'AuraCoil',
        description: 'A neckloop receiver option for hearing aids with an active T-Coil / telecoil program.',
        url: '/products/auracoil-2-pack-auracast-neckloop-receivers'
      },
      bluetooth: {
        title: 'For Bluetooth users',
        product: 'Aura C',
        description: 'A phone bridge option for compatible Bluetooth headphones, earbuds or hearing aids.',
        url: '/products/aura-c-auracast-usb-c-receiver-for-phone'
      },
      venue_receivers: {
        title: 'For visitors without compatible devices',
        product: 'Venue receiver + headphones',
        description: 'Provide an AuraClip receiver with wired headphones as a venue-owned listening option.',
        url: '/products/auraclip-auracast-receiver'
      }
    }
  };
})();
